import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Grid } from '@material-ui/core';
import { useSelector } from 'react-redux';

const useStyles = makeStyles((theme) => ({
    container: {
        padding: theme.spacing(1),
        paddingTop: 0,
        color: '#3f51b5',
        width: '100%',
        justifyContent: 'center',
    },
    title: {
        fontSize: 15,
        fontWeight: 'bold',
        borderBottom: '1px solid #ddd',
        marginBottom: theme.spacing(1),
        paddingBottom: 2,
        color: '#3f51b5',
    },
    subTitle: {
        fontSize: 13,
        fontWeight: 'bold',
        marginBottom: theme.spacing(1),
    },
    name: {
        fontSize: 13,
        fontWeight: 'bold',
        marginBottom: theme.spacing(1),
    },
    text: {
        fontSize: 13,
        marginBottom: theme.spacing(1),
    },
    marginTop: {
        marginTop: theme.spacing(1),
    },
    marginLeft: {
        marginLeft: theme.spacing(1),
    },
}));

const BroadcastMessage = (props) => {
    const classes = useStyles();

    const systemBroadCastMessage = useSelector((state) => state.system.systemNewsAndBroadCastMsg?.broadcastMessage);

    return (
        <Grid container className={classes.container}>
            <pre
                style={{
                    whiteSpace: 'break-spaces',
                    fontSize: 18,
                    fontWeight: 'bold',
                    color: 'red',
                }}
            >
                {systemBroadCastMessage}
            </pre>
        </Grid>
    );
};

export default BroadcastMessage;
